﻿import { LoggingApi } from './LoggingApi'

export class MockLoggingApi implements LoggingApi {
  logDebug(message?: any, ...args: any[]): void {
    console.log(message, ...args)
  }

  logError(message: string, ...args: any[]): void {
    console.error(message, ...args)
  }
}
